import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_empresa/empresa-estoques-grupos";

export const Route = createFileRoute("/_authenticated/empresa-estoques-grupos")({
  head: () => ({
    meta: [
      { title: "Grupos de estoque — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Cadastro dos grupos de estoque, com nome e descrição, usados para organizar os depósitos.",
      },
      { property: "og:title", content: "Grupos de estoque — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Cadastro dos grupos de estoque, com nome e descrição, usados para organizar os depósitos.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
